// ============================================
// HORIZON FITNESS — Script global
// ATC natif Shopify + Cart Drawer + Menu mobile
// ============================================

(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {

        // ================================================
        // 1. MOBILE MENU DRAWER (slide-from-left, multi-niveaux)
        // ================================================
        const mmDrawer = document.getElementById('mobileMenu');
        const menuToggle = document.querySelector('.menu-toggle');

        // Stack pour navigation : [{ id, label }, ...]
        const mmStack = [{ id: 'root', label: '' }];

        const mmGetActive = () => mmDrawer?.querySelector('.mm-level.is-active');
        const mmGetLevel = (id) => mmDrawer?.querySelector(`.mm-level[data-level-id="${id}"]`);
        const mmBackBtn = mmDrawer?.querySelector('.mm-drawer__back');
        const mmBackLabel = mmDrawer?.querySelector('[data-mm-back-label]');

        const mmUpdateBack = () => {
            if (!mmBackBtn || !mmBackLabel) return;
            if (mmStack.length <= 1) {
                mmBackBtn.hidden = true;
                mmBackLabel.textContent = '';
            } else {
                mmBackBtn.hidden = false;
                mmBackLabel.textContent = mmStack[mmStack.length - 1].label;
            }
        };

        const mmOpen = () => {
            if (!mmDrawer) return;
            mmDrawer.classList.add('is-open');
            mmDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('mm-drawer-open');
            // Reset à la racine
            mmDrawer.querySelectorAll('.mm-level').forEach(l => l.classList.remove('is-active', 'is-prev'));
            mmGetLevel('root')?.classList.add('is-active');
            mmStack.length = 0;
            mmStack.push({ id: 'root', label: '' });
            mmUpdateBack();
        };

        const mmClose = () => {
            if (!mmDrawer) return;
            mmDrawer.classList.remove('is-open');
            mmDrawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('mm-drawer-open');
        };

        const mmGoTo = (targetId, label) => {
            const targetLevel = mmGetLevel(targetId);
            const currentLevel = mmGetActive();
            if (!targetLevel || !currentLevel) return;

            // Niveau actuel glisse vers la gauche
            currentLevel.classList.remove('is-active');
            currentLevel.classList.add('is-prev');

            // Nouveau niveau arrive depuis la droite
            targetLevel.classList.remove('is-prev');
            targetLevel.classList.add('is-active');

            mmStack.push({ id: targetId, label });
            mmUpdateBack();
        };

        const mmGoBack = () => {
            if (mmStack.length <= 1) return;
            mmStack.pop();
            const target = mmStack[mmStack.length - 1];

            const currentLevel = mmGetActive();
            const targetLevel = mmGetLevel(target.id);
            if (!currentLevel || !targetLevel) return;

            // Niveau actuel glisse vers la droite (sortie)
            currentLevel.classList.remove('is-active');
            // Le niveau précédent était en is-prev → revient à is-active
            targetLevel.classList.remove('is-prev');
            targetLevel.classList.add('is-active');

            mmUpdateBack();
        };

        // Ouvrir avec le hamburger
        menuToggle?.addEventListener('click', (e) => {
            e.preventDefault();
            mmOpen();
        });

        // Fermer (overlay et croix)
        mmDrawer?.querySelectorAll('[data-mm-close]').forEach(el => {
            el.addEventListener('click', mmClose);
        });

        // Bouton retour
        mmBackBtn?.addEventListener('click', mmGoBack);

        // Aller à un sous-niveau
        mmDrawer?.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-go-to]');
            if (!trigger) return;
            mmGoTo(trigger.dataset.goTo, trigger.dataset.label || '');
        });

        // Touche ESC pour fermer
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && mmDrawer?.classList.contains('is-open')) mmClose();
        });

        // ================================================
        // 2. MEGA-MENU DESKTOP (avec délai à la fermeture)
        // ================================================
        let megaTimer = null;
        const MEGA_DELAY = 200;
        const closeAllMega = () => document.querySelectorAll('.has-submenu.mega-open').forEach(el => el.classList.remove('mega-open'));

        document.querySelectorAll('.has-submenu').forEach(li => {
            li.addEventListener('mouseenter', () => {
                if (window.innerWidth <= 768) return;
                clearTimeout(megaTimer);
                closeAllMega();
                li.classList.add('mega-open');
            });
            li.addEventListener('mouseleave', () => {
                if (window.innerWidth <= 768) return;
                megaTimer = setTimeout(() => li.classList.remove('mega-open'), MEGA_DELAY);
            });
            const sub = li.querySelector('.submenu');
            if (sub) {
                sub.addEventListener('mouseenter', () => clearTimeout(megaTimer));
                sub.addEventListener('mouseleave', () => {
                    megaTimer = setTimeout(() => li.classList.remove('mega-open'), MEGA_DELAY);
                });
            }
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.has-submenu')) closeAllMega();
        });

        // ================================================
        // 3. CART API HELPERS
        // ================================================
        const fetchCart = async () => {
            try {
                const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
                return await res.json();
            } catch (err) {
                console.error('fetchCart error', err);
                return null;
            }
        };

        const formatMoney = (cents) => {
            const euros = (cents / 100).toFixed(2);
            return euros.replace('.', ',') + ' €';
        };

        const updateCartUI = async () => {
            const cart = await fetchCart();
            if (!cart) return null;

            // Compteur dans le header
            document.querySelectorAll('.cart-count').forEach(el => {
                el.textContent = cart.item_count;
                el.style.display = cart.item_count > 0 ? '' : 'none';
            });

            // Mise à jour du contenu du drawer
            const itemsEl = document.getElementById('cartDrawerItems');
            const subtotalEl = document.getElementById('cartDrawerSubtotal');
            if (itemsEl) {
                if (cart.item_count === 0) {
                    itemsEl.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide</p>';
                } else {
                    itemsEl.innerHTML = cart.items.map(item => `
                        <div class="cart-drawer__item">
                            <a href="${item.url}" class="cart-drawer__item-img">
                                ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
                            </a>
                            <div class="cart-drawer__item-info">
                                <h4><a href="${item.url}">${item.product_title}</a></h4>
                                <p class="cart-drawer__item-price">${formatMoney(item.price)} × ${item.quantity}</p>
                            </div>
                            <button class="cart-drawer__remove" type="button" data-line-key="${item.key}" aria-label="Retirer">×</button>
                        </div>
                    `).join('');
                }
            }
            if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

            return cart;
        };

        // ================================================
        // 4. CART DRAWER (mini panier)
        // ================================================
        const cartDrawer = document.getElementById('cartDrawer');

        const openCartDrawer = async () => {
            await updateCartUI();
            if (cartDrawer) {
                cartDrawer.classList.add('is-open');
                cartDrawer.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
            }
        };

        const closeCartDrawer = () => {
            if (cartDrawer) {
                cartDrawer.classList.remove('is-open');
                cartDrawer.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
            }
        };

        // Ouvrir le drawer en cliquant sur l'icône panier du header
        document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(link => {
            link.addEventListener('click', (e) => {
                if (window.innerWidth >= 768) {
                    e.preventDefault();
                    openCartDrawer();
                }
            });
        });

        // Fermer le drawer
        document.querySelectorAll('[data-cart-close]').forEach(el => {
            el.addEventListener('click', closeCartDrawer);
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeCartDrawer();
        });

        // Retirer un article du drawer
        if (cartDrawer) {
            cartDrawer.addEventListener('click', async (e) => {
                const removeBtn = e.target.closest('.cart-drawer__remove');
                if (!removeBtn) return;
                const lineKey = removeBtn.dataset.lineKey;
                if (!lineKey) return;
                removeBtn.disabled = true;
                try {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: lineKey, quantity: 0 })
                    });
                    await updateCartUI();
                } catch (err) {
                    console.error('Remove error', err);
                    removeBtn.disabled = false;
                }
            });
        }

        // ================================================
        // 5. CART TOAST (notification rapide en bas)
        // ================================================
        const toastEl = document.getElementById('cartToast');
        const showToast = (message, type = 'success') => {
            if (!toastEl) return;
            toastEl.textContent = message;
            toastEl.className = 'cart-toast cart-toast--' + type + ' is-visible';
            clearTimeout(toastEl._timer);
            toastEl._timer = setTimeout(() => {
                toastEl.classList.remove('is-visible');
            }, 2500);
        };

        // ================================================
        // 6. INTERCEPTION FORMS NATIFS ATC (le coeur)
        // ================================================
        const interceptAtcForm = (form) => {
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                const submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
                if (submitBtn?.disabled) return;
                if (submitBtn) {
                    submitBtn.dataset._origText = submitBtn.querySelector('.atc-text')?.textContent || submitBtn.textContent;
                    submitBtn.disabled = true;
                    if (submitBtn.querySelector('.atc-text')) {
                        submitBtn.querySelector('.atc-text').textContent = '...';
                    } else {
                        submitBtn.textContent = '...';
                    }
                }

                try {
                    const formData = new FormData(form);

                    // Si la quantité doit venir d'un input externe (data-qty-source), on l'override
                    const qtySource = form.dataset.qtySource;
                    if (qtySource) {
                        const qtyInput = document.querySelector(qtySource);
                        if (qtyInput && qtyInput.value) {
                            formData.set('quantity', qtyInput.value);
                        }
                    } else {
                        // Sinon, chercher un .qty-input dans la page produit principale
                        const pageQty = document.querySelector('.product-info .qty-input, .product-main .qty-input');
                        if (pageQty && pageQty.value && form.closest('.product-info, .product-main, .sticky-atc')) {
                            formData.set('quantity', pageQty.value);
                        }
                    }

                    const res = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                        body: formData
                    });

                    if (!res.ok) {
                        const errData = await res.json().catch(() => ({}));
                        throw new Error(errData.description || errData.message || 'Erreur ajout panier');
                    }

                    await updateCartUI();
                    showToast('✓ Ajouté au panier');
                    setTimeout(() => openCartDrawer(), 200);

                    if (submitBtn) {
                        if (submitBtn.querySelector('.atc-text')) {
                            submitBtn.querySelector('.atc-text').textContent = '✓ Ajouté';
                        } else {
                            submitBtn.textContent = '✓ Ajouté';
                        }
                        submitBtn.style.background = '#28a745';
                        submitBtn.style.color = '#fff';
                        setTimeout(() => {
                            submitBtn.disabled = false;
                            if (submitBtn.querySelector('.atc-text')) {
                                submitBtn.querySelector('.atc-text').textContent = submitBtn.dataset._origText || 'Ajouter au panier';
                            } else {
                                submitBtn.textContent = submitBtn.dataset._origText || 'Ajouter au panier';
                            }
                            submitBtn.style.background = '';
                            submitBtn.style.color = '';
                        }, 1500);
                    }
                } catch (err) {
                    console.error('ATC form error', err);
                    showToast('✗ ' + (err.message || 'Erreur'), 'error');
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        if (submitBtn.querySelector('.atc-text')) {
                            submitBtn.querySelector('.atc-text').textContent = submitBtn.dataset._origText || 'Ajouter au panier';
                        } else {
                            submitBtn.textContent = submitBtn.dataset._origText || 'Ajouter au panier';
                        }
                    }
                }
            });
        };

        // Tous les forms .atc-form (snippet product-card) + tous les forms vers /cart/add
        document.querySelectorAll('form.atc-form, form[action$="/cart/add"]').forEach(interceptAtcForm);

        // ================================================
        // 7. FALLBACK : boutons sans form (data-atc-handle)
        // ================================================
        const pageToHandle = {
            'produit-7-0-at': 'tapis-7-0-at',
            'produit-7-4-at': 'tapis-7-4-at',
            'produit-7-8-at': 'tapis-7-8-at',
            'produit-t101': 'tapis-t101-connect',
            'produit-t202': 'tapis-t202',
            'produit-5-0-ic': 'velo-5-0-ic',
            'produit-7-0-ic': 'velo-7-0-ic',
            'produit-5-0-r': 'velo-5-0-r',
            'produit-5-0-u': 'velo-5-0-u',
            'produit-ex-59': 'elliptique-ex-59'
        };

        const findHandle = (btn) => {
            if (btn.dataset.atcHandle) return btn.dataset.atcHandle;
            const card = btn.closest('.product-card, [data-product-handle]');
            if (card?.dataset.productHandle) return card.dataset.productHandle;
            if (card) {
                const pl = card.querySelector('a[href*="/products/"]');
                if (pl) {
                    const m = pl.getAttribute('href').match(/\/products\/([^/?#]+)/);
                    if (m) return m[1];
                }
                const pgl = card.querySelector('a[href*="/pages/produit-"]');
                if (pgl) {
                    const m = pgl.getAttribute('href').match(/\/pages\/(produit-[^/?#]+)/);
                    if (m && pageToHandle[m[1]]) return pageToHandle[m[1]];
                }
            }
            const cur = window.location.pathname.match(/\/pages\/(produit-[^/?#]+)/);
            if (cur && pageToHandle[cur[1]]) return pageToHandle[cur[1]];
            return null;
        };

        const addToCartByHandle = async (handle, qty, btn) => {
            try {
                const prodRes = await fetch(`/products/${handle}.js`);
                if (!prodRes.ok) throw new Error('Produit introuvable');
                const product = await prodRes.json();
                const variant = product.variants.find(v => v.available) || product.variants[0];
                if (!variant) throw new Error('Pas de variant');

                const addRes = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: variant.id, quantity: qty })
                });
                if (!addRes.ok) {
                    const e = await addRes.json().catch(() => ({}));
                    throw new Error(e.description || e.message || 'Erreur');
                }

                await updateCartUI();
                showToast('✓ Ajouté au panier');
                setTimeout(() => openCartDrawer(), 200);

                if (btn) {
                    const txt = btn.querySelector('.atc-text');
                    if (txt) txt.textContent = '✓ Ajouté';
                    else btn.textContent = '✓ Ajouté';
                    btn.style.background = '#28a745';
                    btn.style.color = '#fff';
                    setTimeout(() => {
                        btn.style.background = '';
                        btn.style.color = '';
                        if (txt) txt.textContent = btn.dataset._origText || 'Ajouter au panier';
                        else btn.textContent = btn.dataset._origText || 'Ajouter au panier';
                        btn.disabled = false;
                    }, 1500);
                }
                return true;
            } catch (err) {
                console.error('ATC fallback error:', err);
                showToast('✗ Produit non disponible', 'error');
                if (btn) {
                    btn.disabled = false;
                    const txt = btn.querySelector('.atc-text');
                    if (txt) txt.textContent = btn.dataset._origText || 'Ajouter au panier';
                    else btn.textContent = btn.dataset._origText || 'Ajouter au panier';
                }
                return false;
            }
        };

        // Boutons qui ne sont pas dans un form
        document.querySelectorAll('.product-card__atc, .btn-cart, .btn-atc').forEach(btn => {
            // Skip si dans un form (déjà géré au-dessus)
            if (btn.closest('form.atc-form') || btn.closest('form[action$="/cart/add"]')) return;

            btn.addEventListener('click', async (e) => {
                e.preventDefault();
                if (btn.disabled) return;

                const handle = findHandle(btn);
                if (!handle) {
                    showToast('✗ Produit non identifié', 'error');
                    return;
                }
                const qtyInput = btn.closest('.product-info, .product-main')?.querySelector('.qty-input');
                const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

                btn.disabled = true;
                const txt = btn.querySelector('.atc-text');
                btn.dataset._origText = txt?.textContent || btn.textContent;
                if (txt) txt.textContent = '...';
                else btn.textContent = '...';

                await addToCartByHandle(handle, qty, btn);
            });
        });

        // ================================================
        // 8. STEPPER QUANTITÉ
        // ================================================
        document.querySelectorAll('.qty-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const wrap = btn.closest('.qty-selector');
                if (!wrap) return;
                const input = wrap.querySelector('.qty-input');
                if (!input) return;
                let val = parseInt(input.value, 10) || 1;
                if (btn.dataset.action === 'plus') val++;
                else if (btn.dataset.action === 'minus' && val > 1) val--;
                input.value = val;
            });
        });

        // ================================================
        // 9. GALERIE PRODUIT (clic thumb change image principale)
        // ================================================
        const mainImg = document.getElementById('pmMainImg');
        const thumbs = document.querySelectorAll('.product-media__thumbs .thumb');
        thumbs.forEach(btn => {
            btn.addEventListener('click', () => {
                const src = btn.dataset.src;
                if (src && mainImg) mainImg.src = src;
                thumbs.forEach(b => b.classList.remove('is-active'));
                btn.classList.add('is-active');
            });
        });

        // ================================================
        // 10. STICKY ATC BAR (page produit)
        // ================================================
        const stickyBar = document.querySelector('.sticky-atc');
        const productMain = document.querySelector('.product-main');
        if (stickyBar && productMain) {
            window.addEventListener('scroll', () => {
                const rect = productMain.getBoundingClientRect();
                if (rect.bottom < 0) stickyBar.classList.add('is-visible');
                else stickyBar.classList.remove('is-visible');
            }, { passive: true });
        }

        // ================================================
        // 11. INIT : compteur panier + animations scroll
        // ================================================
        updateCartUI();

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('fade-in');
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
            document.querySelectorAll('.product-card, .feature-item, .collection-card, .prod-feature-card')
                .forEach(el => observer.observe(el));
        }

        // ================================================
        // 12. FILTRES CATÉGORIE (collection pages)
        // ================================================
        const filterButtons = document.querySelectorAll('.filter-btn');
        const productCards = document.querySelectorAll('.product-card');
        filterButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                filterButtons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                const filter = btn.dataset.filter;
                productCards.forEach(card => {
                    card.style.display = (filter === 'tous' || card.dataset.category === filter) ? '' : 'none';
                });
            });
        });

    });
})();
